import { CreateSellerRequest, Dealer, Seller } from '../../models/dealer.model';

export class SetDealersAction {
  static readonly type = '[Dealer] Set active dealers';
  constructor(
    public dealers: Dealer[],
    public initialDealerId?: string
  ) {}
}

export class SetDealersFailedAction {
  static readonly type = '[Dealer] Set active dealers failed';
}

export class UpdateActiveDealerAction {
  static readonly type = '[Dealer] Update active dealer';
  constructor(public activeDealer: Dealer) {}
}

export class ResetDealerAction {
  static readonly type = '[Dealer] Reset dealer state';
}

export class GetSellersAction {
  static readonly type = '[Dealer API] Get sellers for dealer';
}

export class CreateSellerAction {
  static readonly type = '[Dealer API] Create seller for dealer';
  constructor(public seller: CreateSellerRequest) {}
}

export class CreateSellerSuccessAction {
  static readonly type = '[Dealer API] Create seller for dealer success';
}

export class CreateSellerFailedAction {
  static readonly type = '[Dealer API] Create seller for dealer failed';
}

export class SellerSearchAction {
  static readonly type = '[Dealer API] Search for sellers';
  constructor(public searchPhrase: string) {}
}

export class SellerSearchSuccessAction {
  static readonly type = '[Dealer API] Search for sellers success';
  constructor(public sellers: Seller[]) {}
}

export class SellerSearchFailedAction {
  static readonly type = '[Dealer API] Search for sellers failed';
}

export class GetAllDealersAction {
  static readonly type = '[Dealer API] Get all dealers';
}

export class RemoveSellerFromDealerAction {
  static readonly type = '[Dealer API] Remove seller from dealer';
  constructor(public seller: Seller) {}
}
